class BritishColumbiaObstetricalFileAboRhFactor {
    public BloodGroup: string;
    public BloodRhesus: string;
    public FirstAntibodyTitreDate: Date;
    public SecondAntibodyTitreDate: Date;
    public FirstAntibodyTitreValue: string;
    public SecondAntibodyTitreValue: string;
    public FirstRhImmuneGlobulinDate: Date;
    public SecondRhImmuneGlobulinDate: Date;
    public HemoglobinFirstTrimester: string;
    public HemoglobinThirdTrimester: string;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileAboRhFactor>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFileAboRhFactor };
